import { IFilters } from '../../_models/commonInterface'
import { IRoleData } from '../../_models/superAdmin/roleInterface'
import { _delete, get, post, put } from '../apiServices'

const getRoleList = async (filters: IFilters) => {
  const response = await get('/super-admin/role/list', filters)
  return response
}

const getRoleDetailsById = async (roleId: number) => {
  const response = await get(`/super-admin/role/${roleId}`)
  return response
}

const getPermissionList = async () => {
  const response = await get('/super-admin/permissions')
  return response
}

const createRole = async (newRoleData: IRoleData) => {
  const response = await post('super-admin/role', newRoleData)
  return response
}

const updateRole = async (roleId: number, newRoleData: IRoleData) => {
  const response = await put(`super-admin/role/${roleId}`, newRoleData)
  return response
}
const deleteRole = async (roleId: number) => {
  const response = await _delete(`super-admin/role/${roleId}`)
  return response
}

const fetchUserCount = async (roleId: number) => {
  const response = await get(`super-admin/role/user-count/${roleId}`)
  return response
}

const getBusinessList = async () => {
  const response = await get('super-admin/role/business/list')
  return response
}

const roleService = {
  getRoleList,
  getPermissionList,
  createRole,
  getRoleDetailsById,
  updateRole,
  deleteRole,
  fetchUserCount,
  getBusinessList,
}

export default roleService
